// Update cashback amount when variant changes
document.addEventListener('DOMContentLoaded', function() {
  const productComponents = document.querySelectorAll('[data-js-product-component]');
  
  productComponents.forEach(component => {
    component.addEventListener('VARIANT_CHANGE', function() {
      const variantJson = component.querySelector('[data-js-variant-data]');
      if (!variantJson) return;
      
      const variantData = JSON.parse(variantJson.textContent);
      if (!variantData || !variantData.price) return;
      
      // Calculate cashback - 2% of the price
      const cashbackPercentage = 2;
      const cashbackAmount = Math.round(variantData.price * cashbackPercentage / 100);
      
      // Update the cashback message
      const cashbackElements = component.querySelectorAll('[data-update-block="cashback-main"]');
      cashbackElements.forEach(element => {
        const messageElement = element.querySelector('.product-cashback__message');
        if (messageElement) {
          // Format the message using Shopify's money format function if available
          if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
            messageElement.innerHTML = `You'll earn ${Shopify.formatMoney(cashbackAmount)} in cashback`;
          }
        }
      });
    });
  });
});